module.exports = __webpack_public_path__ + "img/excl-point.45b0df9c.png";